import { render, staticRenderFns } from "./PoolDetailsTab.vue?vue&type=template&id=b9267e6a&scoped=true&"
import script from "./PoolDetailsTab.vue?vue&type=script&lang=js&"
export * from "./PoolDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9267e6a",
  null
  
)

export default component.exports